import posts from './posts.js';

export default {
    bloglist: {
        en: posts.map((post) => ({
            title: post.title,
            poster: post.poster,
            desc: post.desc,
            name: `en-${post.routeName}`,
            url: post.url,
            date: post.date,
        })),
    }
}
